import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormArray, NgForm, FormControl, AbstractControl } from '@angular/forms';
import { ApiServicesService } from '../../../services/api-services.service';
import { bankDetails } from 'src/app/data/models/beneficiaryDetails.model';
import { distinctUntilChanged, map, takeUntil } from 'rxjs/operators';
import { Subject, Subscription } from 'rxjs';
import { AuthenticationService } from '../../../../../services/authentication.service';
import { environment } from "../../../../../../environments/environment";
import { FileUploadLibraryService } from "file-upload-library";
import { CustomValidationService } from 'src/app/services/custom-validation.service';
import moment from 'moment';
import { ToastrService } from 'ngx-toastr';
import * as errorUtils from "src/app/modules/utility/global-utils";
import { ActivatedRoute, Router } from '@angular/router';
import { ReferenceLibraryService } from 'reference-library';
import { MarkCleanFormAction, MarkDirtyFormAction } from 'src/app/app-state/actions/dirty-form.actions';
import { UploadDocumentService } from "src/app/services/upload-document.service";
import { CacheCountryService } from 'src/app/services/cacheCountries.service';
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from "@angular/material/dialog";
import { Store } from '@ngrx/store';
import { ConfirmationModalComponent } from "src/app/modules/shared/modal/confirmation-modal/confirmation-modal.component";
import { acceptedFileTypes } from 'app-models';
import { CustomErrorToastComponent } from 'custom-error-toast';
@Component({
  selector: 'app-bank-details',
  templateUrl: './bank-details.component.html',
  styleUrls: ['./bank-details.component.scss']
})
export class BankDetailsComponent implements OnInit {

  bankDetails: any = {};
  uploadedFile: any;
  bankDetailsForm: FormGroup;
  beneficiaryId: number;
  observableSubscription$ = new Subject();
  @Input() detailsAbout: any;
  @Output() removeElement: EventEmitter<number> = new EventEmitter();
  viewMode: boolean = false;
  showEditButton: boolean = true;
  editDetails: boolean = false;
  currentDate: any;
  beneficiaryType: string;
  isBankDetailsFormReset: boolean = false;
  submitted: boolean = false;
  bankUpdateProfile: boolean = false;
  editModeVal: boolean = false;
  familyId: number;
  employeeId: any;
  companyId: any;
  bulkDownloadCheckboxes: any[] = [];
  selectedFiles: any[] = [];
  @Input() containerId: number;
  bankDetailsArray: any;
  onlyFormBuilder: any;
  formChangesSubscription: any;
  destroy$ = new Subject<void>();
  @Output()
  profileEditStatus: EventEmitter<boolean> = new EventEmitter<boolean>();
  documentFileUploadConfigurations = {
    inputMultipleFlag: true,
    fileType: acceptedFileTypes,
    isFileListRequired: true,
    categoryName: 'BANKDETAILSDOC',
    entityId: 1,
    fileCategory: '',
    listUploadedFiles: [],
    documentTypeRequired: true,
    docummentTypeCode: 'BANKDETAILSDOC',
    useCase: 'beneficiary',
    useCaseId: 1,
    useEntityId: false,
    isDeleteEnabled: this.viewMode ? false : true,
    isUploadEnabled: this.viewMode ? false : true,
    familyId: null,
    family: false
  };

  isFBUser: boolean;
  countryCode: any;
  routingTypes: any[];
  accountTypes: any[];

  constructor(private authenticationService: AuthenticationService,
    public uploadService: FileUploadLibraryService,
    private uploadDocumentService: UploadDocumentService,
    public dialog: MatDialog,
    private bankDetailsFormBuilder: FormBuilder,
    private referenceLibraryService: ReferenceLibraryService,
    private customValidationService: CustomValidationService,
    private router: Router,
    private cacheCountryService: CacheCountryService,
    private route: ActivatedRoute,
    private toastr: ToastrService,
    protected store: Store<any>,
    private apiService: ApiServicesService) {
    this.currentDate = moment().format('YYYY-MM-DD');
    this.companyId = parseInt(sessionStorage.getItem('companyId'));
    this.employeeId = parseInt(this.route.snapshot.queryParams.fbEmpId) ? parseInt(this.route.snapshot.queryParams.fbEmpId) : sessionStorage.getItem('employeeId');
    this.onlyFormBuilder = this.route.snapshot.queryParams.pageFrom;
    if(this.onlyFormBuilder === 'FB') {
      this.beneficiaryId = (sessionStorage.getItem('FbEmployeeId')) ? parseInt(sessionStorage.getItem('FbEmployeeId')) : 0;
    } else {
      this.beneficiaryId = (sessionStorage.getItem('listBeneficiaryId')) ? parseInt(sessionStorage.getItem('listBeneficiaryId')) : this.authenticationService.currentUserValue['beneficiaryId'];
    }
  }

  ngOnInit(): void {
    this.setvalidatations();
    this.getBankDetails();  
    this.documentFileUploadConfigurations.entityId = this.beneficiaryId;
    this.viewMode = sessionStorage.getItem('bene-profile-viewMode') == 'true' ? true : false;

    this.isFBUser = 'isFBUser' in sessionStorage ? sessionStorage.getItem('isFBUser') === 'true' : false;
    this.cacheCountryService.getCountryCode().subscribe(countryCode => {
      this.countryCode = countryCode;
    });
  }
  getBankDetails() {
    this.apiService.getBankDetails(this.beneficiaryId, 'self').pipe(takeUntil(this.observableSubscription$)).subscribe((response: any) => {
      this.bankDetails = response.bankDetailsDTO;
      this.bankDetailsArray = [{
        fileName: this.bankDetails.fileName,
        fileCategory: this.bankDetails.fileCategory,
        fileLocation: this.bankDetails.fileLocation
      }];
      //this.bankDetailsArray = Object.keys(this.bankDetails).map((key) => this.bankDetails[key]);
    });
  }

  download(file) {
    const baseUrl = environment.docs.replace('/docs', '');
    this.uploadService.downloadDocuments(
      baseUrl + file.fileLocation.substring(23),
      this.isFBUser ? file.fileLocation.split('/').slice(-1)[0] : file.fileLocation.substring(23)
    );
  }

  deleteDoc(item) {
    const title = "Confirm";
    const message = "Do you wish to Delete the File?";
    if (item) {
      this.dialogueInitializer(event, title, message)
        .afterClosed()
        .subscribe((result) => {
          if (result) {
            this.removeElement.emit(item);
            this.apiService.deletedfile$.subscribe((status) => {
              this.getBankDetails(); 
            });
          }
        });
    }
  }

  dialogueInitializer(event, title: string, message: string) {
    const cordinates: MouseEventInit = event;
    const dialogRef = this.dialog.open(ConfirmationModalComponent, {
      width: "400px",
      data: {
        update: { title, message },
        buttons: ["Cancel", "Delete"],
      },
    });
    return dialogRef;
  }


  handleEdit(index: number) {
   //  if (this.isBankDetailsFormReset) {
       this.setBankFormData(index);
    //}
    this.referenceLibraryService
    .getDataSource('ROUTINGTYPES', '')
    .pipe(takeUntil(this.observableSubscription$))
    .subscribe((response: any[]) => {
      this.routingTypes = response;
    });
    this.referenceLibraryService
    .getDataSource('BANKINGACCOUNTTYPE', '')
    .pipe(takeUntil(this.observableSubscription$))
    .subscribe((response: any[]) => {
      this.accountTypes = response;
    });
    if (this.bankDetails?.file?.length > 0) {
      this.documentFileUploadConfigurations.inputMultipleFlag = null;
    } else {
      this.documentFileUploadConfigurations.inputMultipleFlag = true;
    }
    this.editDetails = !this.editDetails;
    this.bankDetailsForm.enable();
    //this.editDetails ? this.subscribeValueChanges() : this.unSubscribeValueChanges();
    if (this.editDetails) {
      this.profileEditStatus.emit(true);
    } else {
      this.profileEditStatus.emit(false);
    }
  }
  setBankFormData(index: number) {
    const selectedBankDetail = this.bankDetails[index];

    this.bankDetailsForm.patchValue({
      id: selectedBankDetail.id,
      bankName: selectedBankDetail.bankName,
      routingType: selectedBankDetail.routingType,
      routingNumber: selectedBankDetail.routingNumber,
      accountType: selectedBankDetail.accountType,
      accountNumber: selectedBankDetail.accountNumber,
      branchName: selectedBankDetail.branchName,
      ifscCode: selectedBankDetail.ifscCode,
      bankNomineeName: selectedBankDetail.bankNomineeName,
      nomineeDob: selectedBankDetail.nomineeDob,
      relationshipWithNominee: selectedBankDetail.relationshipWithNominee,
      validReason: selectedBankDetail.validReason
    });

    if (this.onlyFormBuilder === 'FB') {
      this.uploadDocumentService.genericBankGetUploadDocument(this.documentFileUploadConfigurations.useCase, this.documentFileUploadConfigurations.entityId, this.documentFileUploadConfigurations.categoryName, this.documentFileUploadConfigurations.entityId, this.documentFileUploadConfigurations.useEntityId, this.documentFileUploadConfigurations.familyId, selectedBankDetail.id).subscribe((response) => {
        if (response['status'] === 200) {
          this.documentFileUploadConfigurations.listUploadedFiles = response['data'];
          this.documentFileUploadConfigurations = { ...this.documentFileUploadConfigurations };
        } else {
          this.documentFileUploadConfigurations.listUploadedFiles = [];
          this.documentFileUploadConfigurations = { ...this.documentFileUploadConfigurations };
        }
      });
    }
  }
  maxLengthValidator(maxLength: number) {
    return (control: AbstractControl) => {
      if (control.value && control.value.length > maxLength) {
        return { maxLength: true };
      }
      return null;
    };
  }
  
  setvalidatations() {
    this.bankDetailsForm = this.bankDetailsFormBuilder.group({
      id: [],
      bankName: ['', [Validators.required, this.maxLengthValidator(20)]],
      routingType : ['', Validators.required],
      routingNumber : ['', [Validators.required, this.maxLengthValidator(30)]],
      accountType: ['', Validators.required],
      accountNumber: ['', [Validators.required, this.maxLengthValidator(18)]],
      branchName: ['', [Validators.required, this.maxLengthValidator(20)]],
      ifscCode: ['', [this.maxLengthValidator(11)]],
      bankNomineeName: ['', [this.maxLengthValidator(20)]],
      nomineeDob: ['', [this.customValidationService.currentDateValidator(this.currentDate)]],
      relationshipWithNominee: ['', [this.maxLengthValidator(20)]],
      validReason: ['']
    });
    this.formStatusCheck();
  }
  getGlobalErrorMessages(error: string) {
    return errorUtils.errorMessages.get(error);
  }
  saveBankData(isDraft: boolean = false) {
    if (!isDraft) {
      this.submitted = true;
      if (this.bankDetailsForm.invalid) {
        return;
      }
    }
   // if (this.bankDetailsForm.valid) {
      let id = 0; 

      if (this.bankDetailsForm.get('id').value !== null) {
        id = this.bankDetailsForm.get('id').value;
      }
    //let payload = this.bankDetailsForm.value
    const payload = { ...this.bankDetailsForm.value,
      companyId: this.companyId,
      employeeId: this.beneficiaryId,
      id: id
    };

    if (payload.nomineeDob) {
     // const selectedDate = new Date(payload.nomineeDob);
      payload.nomineeDob = moment(payload.nomineeDob).format('YYYY-MM-DD')
    }
    payload['isSaveAsDraft'] = isDraft;
 
    this.apiService.saveBankDetails(payload).subscribe(
      (response: any) => {
        this.toastr.success(response.message, 'Success');
        this.getBankDetails();
        this.clearProfileData(this.bankDetailsForm)
      },
      (error: any) => {
        CustomErrorToastComponent.showErrorToast(this.toastr, error);
      }
    );
  //  }
  }

  backToTask() {
    const taskPageUrl = sessionStorage.getItem('redirectUrl');
    sessionStorage.removeItem('redirectUrl');
    this.router.navigate([`${taskPageUrl}`]);
  }

  clearProfileData(myForm) {
 
    this.isBankDetailsFormReset = true;
    this.bankDetailsForm.disable();
    //myForm.resetForm();
    this.editDetails = !this.editDetails;
    this.profileEditStatus.emit(this.editDetails);
    this.setvalidatations();
  }

  saveAsDraft(event) {
    this.saveBankData(event);
  }
  formStatusCheck() {
    this.formChangesSubscription = this.bankDetailsForm.valueChanges.pipe(
      map(() => this.bankDetailsForm.dirty && this.bankDetailsForm.enabled),
      distinctUntilChanged(),
      takeUntil(this.destroy$)
    ).subscribe(dirty => {
      if (dirty) {
        this.store.dispatch(new MarkDirtyFormAction({
          dirty: true,
          message: "If you leave before saving, all changes made on the 'Bank Details' form will be lost. Do you wish to continue?"
        }));
      } else {
        this.store.dispatch(new MarkCleanFormAction({
          dirty: false,
          message: ""
        }));
      }

    });
  }
  buildDownloadCheckboxes() {
    this.bulkDownloadCheckboxes = [];
    this.selectedFiles = [];
    Object.keys(this.bankDetails).forEach((key) => {
      let tempNode = { isAllSelected: false, childItems: this.bankDetails[key] };
      tempNode.childItems.forEach((child, index) => {
        child["isSelected"] = false;
        child["itemIndex"] = index;
        this.bankDetails[key][index]["itemIndex"] = index;
      });
      this.bulkDownloadCheckboxes[key] = tempNode;
    });
  }
 
  buildSelectedFiles() {
    this.selectedFiles = [];
    Object.keys(this.bulkDownloadCheckboxes).forEach((key) => {
      this.bulkDownloadCheckboxes[key].childItems.forEach((doc) => {
        if (doc["isSelected"])
          this.selectedFiles.push({
            fileLocation: doc.fileLocation,
            fileName: doc.fileName,
          });
      });
    });
  }
}
